let cartItemsIds = JSON.parse(localStorage.getItem('cartItemsIds')) || [];

let cartItems = JSON.parse(localStorage.getItem('cartItem')) || [];

import { PaymentItemService } from '../../_services';
//import { productService } from '@/_services/product.service';

var state = {
    paymentItemList:[],
    cart: cartItems,
	isshowCart: false
};

PaymentItemService.GetPaymentItemList().then(res => {
    state.paymentItemList = res;
});
// let UserMsg = JSON.parse(localStorage.getItem('user'));
// var EmpId=UserMsg.empCompanyId;
// console.log(UserMsg);
// productService.getSysAccountPaymentInfo({ CompanyId:EmpId, demodate: ''}).then(res => {
// 	console.log('getSysAccountPaymentInfo');
// 	console.log(res);
//     state.paymentItemList = res.data;
// });

// Calculate Product stock Counts
function calculateStockCounts(product, quantity) {
	let qty = product.quantity + quantity;
	let stock = product.stockPerAccount;
	if (stock < qty) {
		return false;
	}
	return true;
}

// getters
const getters = {
    getTotalAmount_USD: (state) => {
        return state.cart.reduce((prev, curr) => {
            return prev + curr.priceUSD * curr.quantity;
        }, 0);
    },
    getTotalAmount_RMB: (state) => {
        return state.cart.reduce((prev, curr) => {
            return prev + curr.priceRMB * curr.quantity;
        }, 0);
    },
    getPaymentItemById: (state) => (rid) => {
        return state.paymentItemList.find(x => x.rid === rid );
    },
    getCartPaymentItemById: (state) => (rid) => {
        return state.cart.find(x => x.rid === rid );
    },
};

const mutations = {
	addToCart: (state, payload) => {
		let hasItems = state.cart.find(items => {
			if (items.rid === payload.rid) {
				items.quantity = items.quantity ? items.quantity : 1;
				return true;
			}
			return false;
		});
		if (!hasItems) {
			state.cart.push(payload);
		}
		localStorage.setItem('cartItem', JSON.stringify(state.cart));

	},
    
	updateCartQuantity: (state, payload) => {
		state.cart.find((items, index) => {
			if (items.rid === payload.product.rid) {

				let qty = state.cart[index]['quantity'] + payload.qty;
				let stock = calculateStockCounts(state.cart[index], payload.qty);
				if (qty !== 0 && stock)
					state.cart[index]['quantity'] = qty;
				else
					localStorage.setItem('cartItem', JSON.stringify(state.cart));
				return true;
			}
		});
	},

	removeProduct: (state, payload) => {
		const index = state.cart.indexOf(payload);
		state.cart.splice(index, 1);
		localStorage.setItem('cartItem', JSON.stringify(state.cart));
	},
	clearCart: (state) => {
		state.cart = [];
		localStorage.removeItem('cartItem');
	},
	toggleCart: (state, bool) => {
		if (bool == undefined) {
			state.isshowCart = !state.isshowCart;
		} else {
			state.isshowCart = bool;
		}
	}

};


// actions
const actions = {
	addToCart: (context, payload) => {
		context.commit('addToCart', payload);
	},
	updateCartQuantity: (context, payload) => {
		context.commit('updateCartQuantity', payload);
	},
	removeProduct: (context, payload) => {
		context.commit('removeProduct', payload);
	},
	clearCart: (context) => {
		context.commit('clearCart');
	},
	toggleCart: (context, bool) => {
		context.commit('toggleCart', bool);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};